Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};

    var attributeHelper = new Vendd.inlineEdit.helpers.itemAttributesHelper();

    var getWrapperSelectorSchema = function(defintion)
    {
        if(typeof defintion === 'string')
        {
            return {
                selector: defintion,
                global: false
            };
        }

        if(typeof defintion === 'object')
        {
            return defintion;
        }

        throw new Error('Invalid wrapperSelector definition');
    }

    var attributeEditor = function (element, definition) {

        Vendd.inlineEdit.controlBase.apply(this, [element, definition]);

    };
    attributeEditor.prototype = Object.create(Vendd.inlineEdit.controlBase.prototype);
    attributeEditor.prototype.name = 'attributeEditor';

    attributeEditor.prototype.render = function() {

        var self = this;
        
        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.controlBase.prototype.render.apply(self); })
            .then(function()
            {
                self.element.addClass('hidden');
                
                var wrapperSchema = getWrapperSelectorSchema(self.definition.wrapperSelector);

                self.editorContainer = wrapperSchema.global
                    ? $(wrapperSchema.selector)
                    : $(wrapperSchema.selector, self.getForm().element);

                if(!!!self.editorContainer || self.editorContainer.length <= 0)
                {
                    return Vendd.Promises.Default;
                }

                self.editorContainer.addClass('inline-admin-anchor');
                self.editorContainer.addClass('active');

                var form = self.getForm();

                return Q.Promise(function(resolve, reject)
                {
                    VenddRichTextEditor.inlineEditor(self.editorContainer[0], {
                        value: '',
                        parameters: form.datasources['parameters'].Parameters,
                        iframely: {
                            apiKey: form.datasources['parameters'].Iframely.ApiKey
                        },
                        onChange: function(editor) {
                            
                            setTimeout(function() {
                                
                                var newValue = self.definition.mode === 'text'
                                    ? self.editor.getText()
                                    : self.editor.getData();

                                self.setAttributeValue(newValue);

                            }, 0);
                            
                        }
                    })
                    .then(function (editor) { self.editor = editor; resolve(); })
                    .catch(function (error) { reject(error); });
                });
            })
            ;

    };

    attributeEditor.prototype.bind = function() {

        var self = this;

        if(!!!self.editorContainer || self.editorContainer.length <= 0)
        {
            return Vendd.Promises.Default;
        }

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.controlBase.prototype.bind.apply(self); })
            .then(function()
            {
                if(!!!self.editorContainer)
                {
                    return;
                }

                self.editor.setData(self.getAttributeValue() || '');
                
                Vendd.MessageBus.subscribe(Vendd.inlineEdit.messages.datasourceChanged, self, function (envelope)
                {
                    if(envelope.sender.definition.id === self.definition.id) // ignore self
                    {
                        return;
                    }

                    self.editor.setData(self.getAttributeValue() || '');
                });
            });

    };

    attributeEditor.prototype.getAttributeValue = function()
    {
        var self = this;

        var form = self.getForm();
        var datasource = form.datasources[self.definition.datasource.id];
        
        if(self.definition.nameProvider) // override for name attribute.
        {
            var localization = datasource.ItemsLocalized.find(function (x) { return x.LanguageId === form.languageId; });

            return localization.Name || '';
        }

        var attribute = datasource.ItemAttributes.find(function(x)
        { 
            return x.AttributeCode === self.definition.attribute //checks by code
                && (!x.IsMultilingual || x.LanguageId === form.languageId); // checks by language if applicable
        });
        
        if(!!!attribute)
        {
            return '';
        }

        return attributeHelper.getValue(attribute) || '';
    };

    attributeEditor.prototype.setAttributeValue = function(value)
    {
        var self = this;

        var oldValue = self.getAttributeValue();
        if(oldValue === value)
        {
            return;
        }

        var form = self.getForm();

        var datasource = form.datasources[self.definition.datasource.id];
        
        if(self.definition.nameProvider) // override for name attribute.
        {
            var localization = datasource.ItemsLocalized.find(function (x) { return x.LanguageId === form.languageId; });
            
            localization.Name = value;
        }

        var attribute = datasource.ItemAttributes.find(function(x)
        { 
            return x.AttributeCode === self.definition.attribute //checks by code
                && (!x.IsMultilingual || x.LanguageId === form.languageId); // checks by language if applicable
        });
        
        if(!!!attribute)
        {
            return;
        }

        attributeHelper.setValue(attribute, value);

        Vendd.MessageBus.publishAsync(self, new Vendd.inlineEdit.messages.datasourceChanged(self.definition.id));

    };

    Vendd.inlineEdit.attributeEditor = attributeEditor;

});